import { useSelector } from "react-redux";
import { ReduxStore } from "$redux/reducers";

export const useThemeSelectors = () => {
    const isClassicTheme = useSelector<ReduxStore, boolean>((store) => store.theme.isClassicTheme)

    return { isClassicTheme };
};